import { render, staticRenderFns } from "./AuctionFormLabeledSlider.vue?vue&type=template&id=37c4f4d0"
import script from "./AuctionFormLabeledSlider.vue?vue&type=script&lang=js"
export * from "./AuctionFormLabeledSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports